import { GetOperatorFields } from 'modules/operators/interfaces';
import React from 'react';
import IntroModal from './IntroModal';
import ManualResetModal from './ManualResetModal';

interface PasswordResetModalProps {
  operator: GetOperatorFields;
  onCancel: () => void;
}

const PasswordResetModal = ({
  operator,
  onCancel,
}: PasswordResetModalProps) => {
  const [skipIntro, setSkipIntro] = React.useState(false);

  React.useEffect(() => {
    const script = document.createElement('script');

    script.src = 'https://www.recaptcha.net/recaptcha/api.js';
    script.async = true;
    script.defer = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  React.useEffect(() => {
    const script = document.createElement('script');

    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    script.src = `https://www.recaptcha.net/recaptcha/api.js?render=${process
      .env.REACT_APP_RECAPTCHA_PUBLIC_KEY_ADMIN_20!}`;
    script.async = true;
    script.defer = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return skipIntro ? (
    <ManualResetModal operator={operator} onCancel={onCancel} />
  ) : (
    <IntroModal
      setSkipIntro={setSkipIntro}
      operator={operator}
      onCancel={onCancel}
    />
  );
};

export default PasswordResetModal;
